/**
 * prefixObjectKeys
 * -----------------
 *
 * Prefixes all keys in an object with a specified prefix and divider.
 *
 * @param {Object.<string, any>} object - The object whose keys are to be prefixed.
 * @param {string} prefix - The prefix to add to each key.
 * @param {string} [divider='.'] - The divider to use between the prefix and the original key. Defaults to '.'.
 * @returns {Object.<string, any>} - A new object with the keys prefixed.
 */
export const prefixObjectKeysUtil = <ObjectValue = any>(
	object: { [key: string]: ObjectValue },
	prefix: string = '',
	divider: string = ''
): { [key: string]: ObjectValue } => {
	// Denis: If the object is not an object or is null, return an empty object.
	if (typeof object !== 'object' || object === null) {
		return {};
	}

	// Denis: Prefix all keys in the object with the specified prefix and divider and return the new object.
	return Object.entries(object).reduce(
		(acc, [key, value]: [string, ObjectValue]) => ({
			...acc,
			[`${prefix}${divider}${key}`]: value
		}),
		{}
	);
};
